import { render } from "./UploadH5.vue?vue&type=template&id=8b543cea&scoped=true"
import script from "./UploadH5.vue?vue&type=script&lang=js"
export * from "./UploadH5.vue?vue&type=script&lang=js"

import "./UploadH5.vue?vue&type=style&index=0&id=8b543cea&scoped=true&lang=css"

import exportComponent from "/home/chris/Documents/HELSINKI/Uni_IFT/truscanWebapp/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8b543cea"]])

export default __exports__